/**
 * Default carousel section order for the homepage
 * This order is used when the Lab feature flag for carousel reordering is not enabled
 */
export type HomepageCarouselSectionIdentifier =
  App.LabCarouselSectionOrderPayload['sectionOrder'][number]

export const TRENDING_DESTINATIONS_SECTION_IDENTIFIER: HomepageCarouselSectionIdentifier = 'trendingDestinations'

// Maldives campaign priority for 8 October 2026. Only promote offers already eligible for the carousel.
export const MALDIVES_CAROUSEL_PRIORITISED_OFFER_IDS = [
  '006RF00000OjiFCYAZ', // Hard Rock
  '006RF00000aBtKfYAK', // Villa Nautica
  '006RF00000hKnyHYAS', // The Standard
]

export const DEFAULT_CAROUSEL_ORDER: Array<HomepageCarouselSectionIdentifier> = [
  'componentBannerGroup',
  'upsellSection',
  'frontPageUSP',
  'carHireBundledUpcomingOrder',
  TRENDING_DESTINATIONS_SECTION_IDENTIFIER,
  'maldivesCharterCarousel',
  'offerEndingSoonCarousel',
  'topPicksForMeCarousel',
  'homepageFlightCampaigns',
  'homepageFlightDeals',
  'societeStayUpgradeCarousel',
  'tourOfferCarousel',
  'supportTile',
  'cruiseOfferCarousel',
  'trustIndicatorSection',
  'experienceLuxPlusCarousel',
  'smartExperienceOfferCarousel',
  'marketingCarousel',
  'luxPlusOfferCarousel',
  'hotelOfferCarousel',
  'ultraLuxOfferCarousel',
  'merchandisePointsCarousel',
  'valuePropositionBanner',
  'blogCarousel',
  'browseOfferTypes',
]
